class WorldMap {
  constructor() {
    this.$container = $('.js-world-map');
    this.$body = $('body');
    this.$countryLabel = null;
    this.countries = this.$container.data('countries');

    if (this.$container.length > 0) {
      this.$countryLabel = this.$container.find('.js-map-label');
      this.highlightCountries();
      this.bind();
    }
  }

  bind() {
    if ($(window).width() >= 770) {
      $('.active')
        .mousemove(evt => {
          this.$countryLabel.addClass('visible');
          this._updateText(evt);
        })
        .mouseout(() => {
          this.$countryLabel.removeClass('visible');
        });
    }
  }

  /*
   *  Show the text tool tips
   */
  _updateText(evt) {
    const $target = $(evt.currentTarget);
    const $countryName = $target.attr('title');
    this.$countryLabel.text($countryName);
    this._position(evt, $countryName);
  }

  /*
   *  Position tooltip with mouse movement
   */
  _position(evt) {
    // Adds logic to change position of tooltip when there isnt enough room to display on the right
    const $tooltip = this.$countryLabel;
    const tooltipWidth = $tooltip.outerWidth();
    const tooltipHeight = $tooltip.outerHeight();
    const mouseX = evt.originalEvent.clientX;
    const windowW = $(window).width();
    const positionFromLeft = tooltipWidth + mouseX < windowW;
    const side = positionFromLeft ? 'left' : 'right';
    const Xpos = positionFromLeft ? mouseX : windowW - mouseX;

    $tooltip.attr(
      'style',
      `
      ${side}: ${Xpos}px;
      top: ${evt.originalEvent.clientY - tooltipHeight}px;`,
    );
  }

  highlightCountries() {
    this.countries = this.countries.split(',');
    let countriesOuter = {
      xmin: 10000,
      xmax: 0,
      ymin: 10000,
      ymax: 0,
    };

    for (let i = 0; i < this.countries.length; i += 1) {
      const $country = $(`#${this.countries[i]}`);
      if ($country.length) {
        const countryBox = $country[0].getBBox();
        const countryXMax = countryBox.x + countryBox.width;
        const countryYMax = countryBox.y + countryBox.height;
        const mapPadding = countryBox.width * 0.15;

        countriesOuter = {
          xmin:
            countriesOuter['xmin'] < countryBox.x - mapPadding
              ? countriesOuter['xmin']
              : countryBox.x - mapPadding,
          xmax:
            countriesOuter['xmax'] > countryXMax + mapPadding
              ? countriesOuter['xmax']
              : countryXMax + mapPadding,
          ymin:
            countriesOuter['ymin'] < countryBox.y - mapPadding
              ? countriesOuter['ymin']
              : countryBox.y - mapPadding,
          ymax:
            countriesOuter['ymax'] > countryYMax + mapPadding
              ? countriesOuter['ymax']
              : countryYMax + mapPadding,
        };

        $country.addClass('active');
      }
    }

    //constrain aspect ratio
    const mapWidth = countriesOuter.xmax - countriesOuter.xmin;
    const mapHeight = countriesOuter.ymax - countriesOuter.ymin;
    const currentRatio = mapWidth / mapHeight;
    const targetRatio = 1.3;
    const xOffset =
      currentRatio < targetRatio ? mapWidth * (targetRatio - currentRatio) : 0;

    $('.js-world-map svg').attr(
      'viewBox',
      `${countriesOuter.xmin - xOffset * 0.5} ${
        countriesOuter.ymin
      } ${mapWidth + xOffset} ${mapHeight}`,
    );
    $('.js-world-map').addClass('display-map');
  }
}

export default WorldMap;
